module.exports = __webpack_public_path__ + "assets/CircleTangentPPLDetailed.0371de1502239111d7d7a17892509a0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/CircleTangentPPLDetailed.png
// module id = 497
// module chunks = 0